export default __webpack_public_path__ + "static/media/map-pin.e347d3af.svg";